export default {"productAddToCart":"kfASg","productAddToCartOption":"YPj7U","buyNow":"nIKJ7"};